
export default function Footer() {
  return (
    <footer className="bg-[#e0f1fc] text-gray-900 py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-3 gap-8">
          <div className="md:col-span-2">
            <div className="flex items-center mb-4">
              <img 
                src="https://static.readdy.ai/image/17a64c4d971417c460d286b46dfcd11d/1c8bfb56cc0c5d17ef6a1bd4d8197b46.png"
                alt="会社ロゴ"
                className="w-12 h-12 object-cover object-top rounded-lg mr-3"
              />
              <h3 className="text-2xl font-bold text-gray-900">株式会社アシスト</h3>
            </div>
            <p className="text-gray-700 mb-6 leading-relaxed">
              〒162-0822 東京都新宿区下宮比町2-28 飯田橋ハイタウン1033号
            </p>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4 text-gray-900">資料をダウンロード</h4>
            <ul className="space-y-2">
              <li><a href="#features" className="text-gray-700 hover:text-gray-900 transition-colors cursor-pointer">機能紹介</a></li>
              <li><a href="https://#pricing" className="text-gray-700 hover:text-gray-900 transition-colors cursor-pointer">会社概要</a></li>
              <li><a href="#" className="text-gray-700 hover:text-gray-900 transition-colors cursor-pointer">お問い合わせ</a></li>
              <li><a href="#" className="text-gray-700 hover:text-gray-900 transition-colors cursor-pointer">プライバシーポリシー</a></li>
            </ul>
          </div>
        </div>

        <div className="flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-700 text-sm">
            © 2024 株式会社アシスト
          </p>
          <a href="https://readdy.ai/?origin=logo" className="text-gray-700 hover:text-gray-900 transition-colors cursor-pointer text-sm mt-2 md:mt-0">
            Website Builder
          </a>
        </div>
      </div>
    </footer>
  );
}
